










































































































import DateMixin from "@/mixins/DateMixin";
import AccountIdValdationMixin from "@/mixins/AccountIdValdationMixin";
import { Component, Mixins } from "vue-property-decorator";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import FormValidator from "@/mixins/FormValidator";
import RedStar from "@/components/ui/RedStar.vue";
import { BaseModule } from "@/store/base.module";
import { DalModule } from "@/store/dal.module";
import GlobalMixin from "@/mixins/GlobalMixin";

@Component({
  components: { MonthPicker, RedStar },
})
export default class ChangePasswordView extends Mixins(
  DateMixin,
  AccountIdValdationMixin,
  FormValidator,
  GlobalMixin,
) {
  formRef = "formChangePassw";
  showPassword: boolean = false;
  oldPwd: string = null as any;
  password: string = null as any;
  passwordRepeated: string = null as any;
  innerMessage: string = "";
  loading: boolean = false;

  async savePwd() {
    try {
      this.loading = true;
      if (!this.validateForm()) return;
      // все проверки выполняются на сервере, по reason показываем сообщение
      const res = await DalModule.changePassword({
        oldPassword: this.oldPwd,
        newPassword: this.password,
      });
      if (res?.result === true) {
        BaseModule.showMessage({
          message: "change-pwd.newPwdSetted",
        });
        return;
      }
      BaseModule.showMessage({
        message: this.getChangePasswordError(res),
        color: "error",
      });
    } finally {
      this.loading = false;
    }
  }

  getChangePasswordError(res: any): string {
    switch (res?.reason) {
      case "incorrect-current":
        return this.$t("change-pwd.incorrectCurrent").toString();
      case "invalid-password":
        return this.$t("form-validator.pass").toString();
      case "same-as-old":
        return this.$t("change-pwd.newAndOld").toString();
      case "too-many-attempts":
        return this.$t("change-pwd.tooManyAttempts", {
          minutes: res.retryAfterMinutes,
        }).toString();
    }
    return this.$t("change-pwd.error").toString();
  }

  passwordConfirmationRule() {
    return (
      this.password === this.passwordRepeated ||
      this.$t("form-validator.pass_rep_incorr")
    );
  }

  pwdEqualsOld() {
    return this.password != this.oldPwd || this.$t("change-pwd.newAndOld");
  }

  mounted() {
    // this.oldPwd = "1";
    // this.password = "!Q@W#E4r5t6y";
    // this.passwordRepeated = "!Q@W#E4r5t6y";
  }
}
